import { render, staticRenderFns } from "./MasterAwbcreated.vue?vue&type=template&id=30f965bb&"
import script from "./MasterAwbcreated.vue?vue&type=script&lang=js&"
export * from "./MasterAwbcreated.vue?vue&type=script&lang=js&"
import style0 from "./MasterAwbcreated.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports